export const setSmallChatEmail = (email: string) => {
  try {
    window.Smallchat?.set('email', email);
  } catch (err) {}
};
